import log from "loglevel";

export const initLogger = () => {
  log.disableAll();
};
